import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { CarrierEntity } from './carrier.entity';
import { CompanyEntity } from './company.entity';
import { ShipmentDetailEntity } from './shipment-detail.entity';

@Index('fk_company__id', ['fkCompanyId'], {})
@Index('shipment__fk_carrier__id_fk', ['fkCarrierId'], {})
@Index('shipment__fk_warehouse__id', ['fkWarehouseId'], {})
@Index('shipment_externalId_uindex', ['externalId'], { unique: true })
@Entity('shipment')
export class ShipmentEntity extends BaseEntity {
	@Column('varchar', {
		name: 'externalId',
		nullable: true,
		unique: true,
		length: 255,
	})
	public externalId!: string | null;

	@Column('datetime', { name: 'date', nullable: true })
	public date!: Date | null;

	@Column('varchar', { name: 'trackingNumber', nullable: true, length: 255 })
	public trackingNumber!: string | null;

	@Column('varchar', { name: 'trackingUrl', nullable: true, length: 255 })
	public trackingUrl!: string | null;

	@Column('varchar', { name: 'shipVia', nullable: true, length: 255 })
	public shipVia!: string | null;

	@Column('decimal', {
		name: 'freight',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public freight!: string | null;

	@Column('varchar', { name: 'status', length: 255, default: () => "'1'" })
	public status!: string;

	@Column('datetime', { name: 'expectedDeliveryDate', nullable: true })
	public expectedDeliveryDate!: Date | null;

	@Column('datetime', { name: 'lastImportDate', nullable: true })
	public lastImportDate!: Date | null;

	@Column('int', { name: '_fk_carrier__id', nullable: true, unsigned: true })
	public fkCarrierId!: number | null;

	@Column('int', {
		name: 'fk_company__id',
		unsigned: true,
		default: () => "'1'",
	})
	public fkCompanyId!: number;

	/**
	 * PD-17225 — the warehouse the shipment left from. Empty for drop shipments
	 * and goods that do not ship from a warehouse. Column and index only, no
	 * database foreign key.
	 */
	@Column('int', { name: 'fk_warehouse__id', nullable: true, unsigned: true })
	public fkWarehouseId!: number | null;

	@ManyToOne(() => CompanyEntity, (company) => company.shipments, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_company__id', referencedColumnName: 'id' }])
	public fkCompany!: CompanyEntity;

	@ManyToOne(() => CarrierEntity, (carrier) => carrier.shipments, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_carrier__id', referencedColumnName: 'id' }])
	public fkCarrier!: CarrierEntity;

	@OneToMany(
		() => ShipmentDetailEntity,
		(shipmentDetail) => shipmentDetail.shipment,
		{},
	)
	public shipmentDetails!: Array<ShipmentDetailEntity>;
}
